import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit,
  ViewChild,
  Input,
} from '@angular/core';
@Component({
  selector: 'jsg-multi-row-panel',
  templateUrl: './multi-row-panel.component.html',
  styleUrls: ['./multi-row-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiRowPanelComponent implements OnInit {
  @Input() showSeparator: boolean = true;
  constructor() {}
  @ViewChild('ref', { static: false }) div: any;
  ngOnInit(): void {}
}
